module.exports = __webpack_public_path__ + "img/rename.b3c52e6a.svg";